'use client';

import React from 'react';
import Script from 'next/script';

interface SchemaInjectorProps {
  schemas: Array<{
    id: string;
    data: Record<string, any>;
  }>;
}

export default function SchemaInjector({ schemas }: SchemaInjectorProps) {
  return (
    <>
      {schemas.map((schema) => (
        <Script
          key={schema.id}
          id={schema.id}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema.data),
          }}
        />
      ))}
    </>
  );
}
